import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { TaskListStyleConfig } from '../interfaces';

export const TaskListStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: (props: TaskListStyleConfig) => ({
      backgroundColor: props.backgroundColor || theme.palette.background.default,
      minHeight: 'calc(100vh - 40px - 165px)',
      [theme.breakpoints.up('md')]: {
        minHeight: 'calc(100vh - 50px - 165px)',
      },
      [theme.breakpoints.up('lg')]: {
        minHeight: 'calc(100vh - 50px - 97px)',
      },
    }),
    penultimateText: {
      padding: '2rem 0px 2rem 0px',
    },
    candidateFeedbackText: {
      fontWeight: 500,
    },
    contentContainer: {
      marginLeft: 'auto',
      marginRight: 'auto',
      [theme.breakpoints.up('sm')]: {
        maxWidth: '592px', // 92.5%
      },
      [theme.breakpoints.up('md')]: {
        maxWidth: '608px', // 79.1%
      },
      [theme.breakpoints.up('lg')]: {
        maxWidth: '864px', // 84.3%
      },
      [theme.breakpoints.up('xl')]: {
        maxWidth: '1140px', // 83.4%
      },
    },
    paperColor: (props: TaskListStyleConfig) => ({
      backgroundColor: props.taskContainerColor || theme.palette.background.paper,
    }),
    contentSpacing: (props: TaskListStyleConfig) => ({
      padding: '1.25rem 1.5rem 2.5rem',
      [theme.breakpoints.down('sm')]: {
        paddingBottom: props.isICPEnabled ? '4rem' : '',
      },
      [theme.breakpoints.up('sm')]: {
        padding: '1.25rem 0 2rem',
      },
      [theme.breakpoints.up('md')]: {
        padding: '1.25rem 0 2.5rem',
      },
      [theme.breakpoints.up('xl')]: {
        padding: props.bannerImage ? '1.25rem 0rem 5rem' : '5rem 0',
      },
    }),
    taskListLabelContainer: {
      overflow: 'hidden',
    },
    taskListLabel: (props: TaskListStyleConfig) => ({
      '@supports not (-ms-high-contrast: none)': {
        display: 'flex',
        color: props.labelColor,
        marginTop: props.content ? '2rem' : 0,
        '&::after': {
          content: '""',
          flex: '1 1',
          borderColor: props.labelColor,
          borderBottom: '2px solid',
          margin: 'auto',
          marginLeft: '1rem',
        },
        [theme.breakpoints.up('sm')]: {
          marginTop: props.content ? '2.5rem' : 0,
        },
        [theme.breakpoints.up('lg')]: {
          marginTop: props.content ? '3rem' : 0,
        },
      },
      '@media screen and (-ms-high-contrast: none)': {
        position: 'relative',
        color: props.labelColor,
        '&::after': {
          content: '""',
          position: 'absolute',
          top: '50%',
          height: '1px',
          borderBottom: '2px solid',
          width: '90%',
          marginLeft: '1rem',
        },
        [theme.breakpoints.up('sm')]: {
          marginTop: props.content ? '2.5rem' : 0,
        },
        [theme.breakpoints.up('lg')]: {
          marginTop: props.content ? '3rem' : 0,
        },
      },
    }),
    tileGrid: {
      marginTop: '2rem',
      width: '100%',
      // All browsers except IE
      '@supports not (-ms-high-contrast: none)': {
        display: 'grid',
        gridGap: '1.5rem',
        [theme.breakpoints.down('xs')]: {
          alignItems: 'start',
        },
        [theme.breakpoints.up('sm')]: {
          gridAutoRows: '1fr',
          gridTemplateColumns: '1fr 1fr',
        },
        [theme.breakpoints.up('lg')]: {
          gridAutoRows: '1fr',
          gridTemplateColumns: '1fr 1fr 1fr',
        },
      },
      // IE only
      '@media screen and (-ms-high-contrast: none)': {
        display: 'flex',
        flexWrap: 'wrap',
      },
      [`@media screen and (-ms-high-contrast: none) and (min-width: ${theme.breakpoints.values.sm}px) and (max-width: ${
        theme.breakpoints.values.lg - 1
      }px)`]: {
        '& > div:nth-of-type(2n)': {
          marginLeft: '4%',
        },
      },
      [`@media screen and (-ms-high-contrast: none) and (min-width: ${theme.breakpoints.values.lg}px)`]: {
        '& > div:nth-of-type(3n - 1)': {
          marginLeft: '2%',
          marginRight: '2%',
        },
      },
    },
  }),
);
